/* ========================================================================
 * Apricot's Colors Module
 * ======================================================================== */

// json
import CBColorData from '../api/CBColor'

export default CBColorData
